// extracted by mini-css-extract-plugin
module.exports = {"component":"special-hotel-badge_component__J3c65","badge":"special-hotel-badge_badge__UWvSL"};